import React from "react";
import "./FAQs.css";

function FAQs() {
  return (
    <div className="freq-container" id="faqs">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 faq-img-cont">
            <img className="faq-image" src="assets/FAQ.png" alt="faq-image" />
          </div>
          <div className="col-lg-8 col-md-6 col-sm-12">
            <div className="faq-container">
              <div className="faq-item">
                <div className="faq-question">When and where is the reunion taking place?</div>
                <div className="faq-answer">
                The reunion will be held on <b>Friday, Dec 27, 2024 at IITM Campus, Chennai.</b> Detailed venue information and a schedule of events will be shared with registered attendees.
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">How can I register for the reunion?</div>
                <div className="faq-answer">
                You can register online via the reunion portal at this <a href="https://iitmaa.org/events/12021" target="_blank" rel="noreferrer">link</a>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">Are family members allowed to attend?</div>
                <div className="faq-answer">
                <b>Yes!</b> Family members are welcome. Be sure to include their details during registration so we can plan activities accordingly.
                </div>
              </div>
              <div className="faq-item">
                <div className="faq-question">Can I view the list of batchmates attending the reunion?</div>
                <div className="faq-answer">
                You can view the list of registered attendees <a href="https://iitmaa.org/events/attendees/12020?source=eventlist" target="_blank">here</a>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                How can I contribute to the class gift this year?
                </div>
                <div className="faq-answer">
                <b>You can find a cause list below.</b> Discuss it with your classmates, and select the cause you want to donate. 
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">What are some examples of class gifts given by previous batches during their recent reunions? </div>
                <div className="faq-answer">
                MCM Scholarships, Centre of Innovation, Entrepreneurship and Innovation Fund are some examples of class gifts in recent years.
                </div>
              </div>
              <div className="faq-item">
                <div className="faq-question">Is my donation tax-deductible?</div>
                <div className="faq-answer">
                Yes, all donations made to the institution are <b>100% tax-deductible.</b> You will receive a receipt for your contribution for tax purposes.
                </div>
              </div>
              <div className="faq-item">
                <div className="faq-question">Who can I contact for further questions or assistance?</div>
                <div className="faq-answer">
                If you have additional questions, please reach out to <b>IITMAA at +91 7397284362 or email at alumni@iitm.ac.in</b>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQs;
